/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyMethodModel } from '../../models/client-survey-method-model';

export interface GetSurveyMethods$Json$Params {
}

export function getSurveyMethods$Json(http: HttpClient, rootUrl: string, params?: GetSurveyMethods$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyMethodModel>>> {
  const rb = new RequestBuilder(rootUrl, getSurveyMethods$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientSurveyMethodModel>>;
    })
  );
}

getSurveyMethods$Json.PATH = '/api/SurveyMethod';
